var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scriptoriums",attrs:{"id":"select-scriptorium"}},[_c('Select2',{ref:"select2",attrs:{"settings":_vm.selectConfig,"tabindex":"0"},on:{"select":function($event){return _vm.select($event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }